import React from 'react';
import DashboardTabsArrow from './DashboardTabsArrow';

const DashboardTabsHeader = ({
    className,
    tabsClassName,
    tabsStyle,
    onDrop,
    onDragOver,
    children,
    actions,
}) => (
    <div className={className}>
        <DashboardTabsArrow direction={-1} />
        <div
            className={tabsClassName}
            style={tabsStyle}
            onDrop={onDrop}
            onDragOver={onDragOver}
        >
            {children}
        </div>
        <DashboardTabsArrow direction={1} />
        {actions}
    </div>
);

export default DashboardTabsHeader;
